import { MobileStates, WidgetStates } from '../WidgetLarge/Widget';
// Helpers for pulling query params from host url
export var getUrlParam = function (param) {
    var params = new URLSearchParams(window.location.search);
    return params.get(param) || '';
};
export var getAllUrlParams = function (param) {
    var params = new URLSearchParams(window.location.search);
    return params.getAll(param);
};
export var getComplaintParam = function () { return getUrlParam('complaint'); };
export var hasDefaultExpandedParam = function (mobileState) {
    var targetStates = getTargetStateParams(mobileState);
    var hasDefaultExpandedTarget = targetStates.find(function (_a) {
        var targetState = _a.targetState, targetDelay = _a.targetDelay;
        return targetState === WidgetStates.EXPANDED && targetDelay === 0;
    });
    return (getUrlParam('widgetAutoExpandTime') === '0' ||
        getInitialState(mobileState) === WidgetStates.EXPANDED ||
        !!hasDefaultExpandedTarget);
};
export var getIntialStateIsHidden = function (mobileState) {
    var targetStates = getTargetStateParams(mobileState);
    var hasDefaultHiddenTargetState = targetStates.find(function (_a) {
        var targetState = _a.targetState, targetDelay = _a.targetDelay;
        return targetState === WidgetStates.HIDDEN && targetDelay === 0;
    });
    return getUrlParam('widgetInitialState') === 'hidden' || hasDefaultHiddenTargetState;
};
export var getAutoExpandTiming = function (mobileState) {
    var overrideExpansionBehavior = getUrlParam('widgetInitialState') === 'expanded' ||
        getUrlParam('widgetTargetState') ||
        (mobileState === MobileStates.MOBILE && getUrlParam('widgetTargetState-m'));
    if (overrideExpansionBehavior) {
        // Ignore timing param when widgetInitialState is expanded
        // Or after converting to widgetTargetState params
        // (where customers can control this explicitly)
        return;
    }
    // todo: Remove auto expand default behavior once corewell converts to widgetTargetStaet
    // params - would prefer to enforce explicit timing
    var defaultTiming = 10000;
    var timing = getUrlParam('widgetAutoExpandTime');
    if (timing && !isNaN(parseFloat(timing))) {
        return parseFloat(timing);
    }
    return defaultTiming;
};
var stringToWidgetState = function (widgetStateString) {
    if (!widgetStateString) {
        return;
    }
    var normalizedString = widgetStateString.toUpperCase();
    return Object.values(WidgetStates).find(function (state) { return state.toUpperCase() === normalizedString; });
};
export var getInitialState = function (mobileState) {
    var _a, _b, _c;
    if (mobileState === MobileStates.MOBILE) {
        return ((_b = (_a = stringToWidgetState(getUrlParam('widgetInitialState-m'))) !== null && _a !== void 0 ? _a : stringToWidgetState(getUrlParam('widgetInitialState'))) !== null && _b !== void 0 ? _b : WidgetStates.COLLAPSED);
    }
    return (_c = stringToWidgetState(getUrlParam('widgetInitialState'))) !== null && _c !== void 0 ? _c : WidgetStates.COLLAPSED;
};
var getParamsWithFallback = function (key, fallbackKey) {
    var params = getAllUrlParams(key);
    return params.length > 0 ? params : getAllUrlParams(fallbackKey);
};
export var getTargetStateParams = function (mobileState) {
    if (mobileState === MobileStates.UNKNOWN) {
        return [];
    }
    var params = mobileState === MobileStates.MOBILE
        ? getParamsWithFallback('widgetTargetState-m', 'widgetTargetState')
        : getAllUrlParams('widgetTargetState');
    if (params.length < 1) {
        return [];
    }
    return params
        .map(function (param) {
        var _a = param.split(','), state = _a[0], delay = _a[1];
        var targetState = stringToWidgetState(state);
        var targetDelay = parseInt(delay);
        if (!targetState || !delay) {
            return;
        }
        return {
            targetState: targetState,
            targetDelay: targetDelay,
        };
    })
        .filter(function (item) { return item != null; });
};
